module.exports = __webpack_public_path__ + "static/media/call-center.95b31ebe.webp";